import { api } from '../..';
import { mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getLanguages = (): Promise<PropertyType> =>
	api.get('/languages').then((res) => {
		return mapApiToEntity(res.data);
	});
